import { defineComponent as _defineComponent } from 'vue'
import { useRouter } from 'vue-router/composables';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { BaseIcon, BaseText } from '@warrenbrasil/nebraska-web';
import * as trackEvents from '../track-events';
import HomeHeroSummaryLoader from './HomeHeroSummaryLoader.vue';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeHeroSummary',
  props: {
    isLoading: { type: Boolean },
    hasError: { type: Boolean },
    balance: null
  },
  setup(__props: any) {

const props = __props as {
  isLoading: boolean;
  hasError: boolean;
  balance: string;
};



const router = useRouter();

const buttonClass = computed(() => {
  return `home_hero__pending-balance--content${
    props.isLoading ? ' disabled' : ''
  }
  `;
});

function redirectToTransactionsPage() {
  if (!props.isLoading) {
    trackEvents.trackViewMoreTransactionsEvent();
    router.push({ name: 'transactions' });
  }
}

return { __sfc: true,props, router, buttonClass, redirectToTransactionsPage, NebraskaColors, BaseIcon, BaseText, HomeHeroSummaryLoader }
}

})